import { styled, IconButton } from "@mui/material";

interface ExpandMoreProps extends React.ComponentProps<typeof IconButton> {
  expanded: string;
}

export const ExpandMore = styled(IconButton)<ExpandMoreProps>(({ theme, expanded }) => ({
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  transform: expanded === 'true' ? 'rotate(180deg)' : 'rotate(0deg)', 
}));
